import { render, staticRenderFns } from "./DashIndustriaGrafico.vue?vue&type=template&id=5af6e09a&"
import script from "./DashIndustriaGrafico.vue?vue&type=script&lang=js&"
export * from "./DashIndustriaGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports